import { Component, Input, OnInit } from '@angular/core';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector   : 'my-tabs',
    template: require('./tabs.component.html'),
    styles: [require('./tabs.component.scss')]
})

export class TabsComponent implements OnInit{

    @Input() tabs: any;
    @Input('privateId') privateId:string;

    constructor(public customerService:CustomerService) {

    }

    ngOnInit(): void{

    }

    changeTab(tab: any): void {
        this.customerService.tabActive = tab.title;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/tabs/tabs.component.ts